import Footer from "../../components/common/footer";
import HeaderTwo from "../../components/common/headerTwo";
import { Helmet } from "react-helmet";
import Offer3Projektowanie from "../../components/offer/3projektowanie";

function K1MulczerLesny() {
  return (
    <>
      <Helmet>
        <title>Projektowanie ogrodów przydomowych i koncepcje zieleni | Gdańsk, Gdynia, Kaszuby</title>
        <meta name="title" content="Projektowanie ogrodów przydomowych i koncepcje zieleni | Gdańsk, Gdynia, Kaszuby" />
        <meta
          name="description"
          content="Tworzymy funkcjonalne projekty ogrodów dostosowane do Twojej działki i stylu życia. Projektowanie terenów zielonych w Gdańsku, Gdyni, Wejherowie, Kartuzach i na Kaszubach."
          key="desc"
        />
        <meta
          property="og:title"
          content="Projektowanie ogrodów przydomowych i koncepcje zieleni | Gdańsk, Gdynia, Kaszuby"
        />
        <meta
          property="og:description"
          content="Tworzymy funkcjonalne projekty ogrodów dostosowane do Twojej działki i stylu życia. Projektowanie terenów zielonych w Gdańsku, Gdyni, Wejherowie, Kartuzach i na Kaszubach."
        />
        <meta
          property="og:image"
          content="https://magazyn.drzewus.pl/wp-content/uploads/2024/11/logo-white-10.55.05.png"
        />
      </Helmet>
      <HeaderTwo />
      <main className="relative z-40">
        <Offer3Projektowanie />
      </main>
      <Footer />
    </>
  );
}
export default K1MulczerLesny;
